import React from 'react';

export default class GameScore extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  count() {
    let success = 0;
    let fail = 0;
    if (this.props.scoreCard.length == 0) {
      return [0, 0];
    }
    this.props.scoreCard.map((score) => {
      score ? success++ : fail++;
    });
    return [success, fail];
  }

  ratio() {
    const count = this.count();
    const success = count[0];
    const fail = count[1];
    return `${success}/${success + fail}`;
  }

  percent() {
    const count = this.count();
    const success = count[0];
    const fail = count[1];
    const percent = Math.ceil(success/(success + fail) * 100);
    return percent + '%';
  }

  render() {
    let color, label = 'Score Card!', ratio, percent;
    if (this.props.selected) {
      const success = (this.props.lastCurrent == this.props.selected);
      label = success ? 'Success' : 'Sorry, try again';
      if (this.props.completed) {
        label = 'You win!';
      }
      color = success ? 'hidden-picture__result-success' : 'hidden-picture__result-failed';
    }
    else { // Hasn't selected anything
      ratio = this.ratio();
      percent = this.percent();
      if (ratio !== '0/0') {
        label = `Score: ${ratio} - ${percent}`;
      }
      color = '';
    }

    const classes = `hidden-picture__result ${color}`;
    return(
      <div className={classes}>
        {label}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/hidden-picture/game-score.js
 **/